import { getStatisticsHistoryRequest } from "../../utils/kbt-api";
import { AppDispatch } from "../hooks";

export const STATISTICS_SET_PAGE = "STATISTICS_SET_PAGE" as const;
export const STATISTICS_SET_PAGE_SIZE = "STATISTICS_SET_PAGE_SIZE" as const;
export const STATISTICS_FETCH_PENDING = "STATISTICS_FETCH_PENDING" as const;
export const STATISTICS_FETCH_SUCCESS = "STATISTICS_FETCH_SUCCESS" as const;
export const STATISTICS_FETCH_ERROR = "STATISTICS_FETCH_ERROR" as const;
export const STATISTICS_RESET = "STATISTICS_RESET" as const;

export const STATISTICS_PAGE_SIZE = 20;

export type TStatisticsHistoryItem = {
  user_id: string;
  error_count: number;
  keystrokes_count: number;
  text_length: number;
  typing_speed: number;
  accuracy: number;
  error_rate: number;
  elapsed_time: number;
  created_at: string;
};

export const setStatisticsPage = (page: number) => ({
  type: STATISTICS_SET_PAGE,
  payload: page,
});

export const setStatisticsPageSize = (pageSize: number) => ({
  type: STATISTICS_SET_PAGE_SIZE,
  payload: pageSize,
});

export const resetStatistics = () => ({
  type: STATISTICS_RESET,
});

export const fetchStatistics = (
  userId: string,
  page: number,
  pageSize: number = STATISTICS_PAGE_SIZE
) => {
  return (dispatch: AppDispatch) => {
    const offset = (page - 1) * pageSize;

    dispatch({
      type: STATISTICS_FETCH_PENDING,
    });

    return getStatisticsHistoryRequest(userId, offset, pageSize)
      .then((response) => {
        dispatch({
          type: STATISTICS_FETCH_SUCCESS,
          payload: {
            items: response.items,
            count: response.count,
          },
        });
      })
      .catch(() => {
        dispatch({
          type: STATISTICS_FETCH_ERROR,
          payload: "Failed to load statistics.",
        });
      });
  };
};

export type TStatisticsActions =
  | ReturnType<typeof setStatisticsPage>
  | ReturnType<typeof setStatisticsPageSize>
  | ReturnType<typeof resetStatistics>
  | {
      type: typeof STATISTICS_FETCH_PENDING;
    }
  | {
      type: typeof STATISTICS_FETCH_SUCCESS;
      payload: {
        items: TStatisticsHistoryItem[];
        count: number;
      };
    }
  | {
      type: typeof STATISTICS_FETCH_ERROR;
      payload: string;
    };
